import { includes } from 'lodash-es'

import AlbumContent from 'components/pages/Album/AlbumContent'
import MetaTags from 'components/pages/Album/AlbumContent/MetaTags'
import NoindexRemoval from 'components/common/NoindexRemoval'
import withLivingSinyi from 'utils/withLivingSinyi'
import withSafeServerSideProps from 'utils/server-utils/with-safe-server-side-props'
import {
  getAlbumByUrlId,
  getAlbumPhotos,
  getPhotoClassifications,
} from 'utils/api'

const AlbumContentPage = (props) => {
  return (
    <>
      <NoindexRemoval />
      <MetaTags
        resolvedUrl={props.resolvedUrl}
        album={props.fallbackData?.album}
        photoClassifications={props.fallbackData?.photoClassifications}
      />
      <AlbumContent {...props} />
    </>
  )
}

export const getServerSideProps = withSafeServerSideProps(async (context) => {
  const urlIdSource = context.params?.albumUrlId

  const albumPromise = getAlbumByUrlId(urlIdSource)
  const photoClassificationsPromise = getPhotoClassifications()

  const [albumResult, photoClassificationsResult] = await Promise.all([
    albumPromise,
    photoClassificationsPromise,
  ])
  const [album, albumError] = albumResult
  const [
    photoClassifications,
    photoClassificationsError,
  ] = photoClassificationsResult

  if (albumError) {
    // API 失敗 ≠ 相簿不存在，丟給 withSafeServerSideProps 分流
    throw albumError
  }
  if (!album) {
    // 確認查無相簿：回真 404，取代原本的 200 空殼（meta 會出現 undefined 字樣）
    return { notFound: true }
  }

  // album 確定存在才查照片，避免對 lsGet(null) 打出無效請求
  const [photos, photosError] = await getAlbumPhotos(album._id)

  return {
    props: {
      fallbackData: {
        photoUrlId: context.query?.photoId || '',

        // fetched data
        album,
        photos: photos ?? [],
        photoClassifications: photoClassifications ?? [],
      },
      resolvedUrl: context.resolvedUrl,
      back: context.query.back || false,
    },
  }
})

export default withLivingSinyi(AlbumContentPage)
